(function () {
    'use strict';

    angular.module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider.state('public', {
            abstract: true,
            parent: 'site',
            views: {
                'header@': {
                    templateUrl: 'app/layouts/header-bidiso/header-bidiso.html',
                    controller: "HeaderBidisoController",
                    controllerAs: 'ctrl'
                },
                'navbar@': {
                    template: '<mi-menu-bidiso menu="$ctrl.menu" nav-collapsed="$ctrl.navCollapsed" modal="$ctrl.modal(id)"></mi-menu-bidiso>',
                    controller: ['menuData', '$window', function (menuData, $window) {
                        this.menu = menuData;
                        this.navCollapsed = $window.innerWidth < 992;
                    }],
                    controllerAs: '$ctrl',
                    resolve: {
                        menuData: ['Menu',
                            function (Menu) {
                                return Menu.getMenu('menu-main');
                            }
                        ]
                    }
                },
                'footer@': {
                    templateUrl: 'app/layouts/footer/footer.bidiso.html'
                }
            },
            resolve: {
                /* @ngInject */
                isAdmin: function ($rootScope) {
                    $rootScope.isAdmin = false;
                },
                bidisoUrl: function ($rootScope, $http) {
                    $http({
                        method: 'GET',
                        url: 'api/config-env/getBidisoUrl'
                    }).then(function successCallback(response) {
                        $rootScope.bidisoURL = response.data;
                    }, function errorCallback(error) {
                        console.log('Error al obtener la configuración de Bidiso', error);
                    });
                }

            }
        });
    }
})();
